<template>
  <div class="voting-module">

      <router-link tag="div" :to="`/talent/${this.$route.params.id}`" class="voting-plus-icon"><plus-icon  class="plusicon"></plus-icon></router-link>

      <div class="title-box pt-4">
          <h4>فستیوال خوانندگی</h4>
          <div class="talent-des">در این فستیوال از سر تا سر کشور میتوانید استعداد خود را به نمایش بگذارید.</div>
      </div>

      <div class="order-vote d-flex justify-content-center mt-4">
        <h4> برای ارسال آثار روی کلید  <plus-icon  class="plusicon"></plus-icon>  کلیک کنید </h4>
      </div>

    <div class="voting-lists">
      <div v-for="list in lists" @click="gotoCandidate(list.id,list.des,list.title,list.active,list.status)" class="vote-item mt-4">
        <div class="title-box">
            <h3>{{list.title}}</h3>
            <p>{{list.des}}</p>
        </div>

        <div class="vote-image-background" :class="[list.active == 1 ? 'activeVote' : 'disActiveVote']"><img :src="list.status == 2 ? 'https://kishoto.ir/images/votes_data_type2.png' : 'https://kishoto.ir/images/votes_data_type1.png'" ></div>
      </div>
    </div>

  </div>
</template>

<script>

import PlusIcon from 'vue-material-design-icons/Plus.vue';

import store from "@/store";

export default {
  data() {
    return {
      lists: null,
      loggined:false
    };
  },
  components:{
    PlusIcon
  },
  created() {
      this.getVote();
      this.authcheck();
  },
  methods: {
    async getVote() {
      let fd = new FormData();
      fd.append("vid", this.$route.params.id);

      const response = await this.$ApiServiceLayer.post("get_votes_level",fd);
      if (response.status_code === 200) {
        this.lists = response.list;
      }
    },
    authcheck(){
      console.log("checking auth");
      console.log("this is new js file! 2");

      if(store.state.login.loginTempToken){
        //this.getProfile();
        this.loggined = true;
        console.log("loggined!");
      }else{
        this.loggined = false;
        console.log("not loggined!");
      }
    },
    gotoCandidate(id,des,title,active,status){

      console.log(active);

      if(this.loggined){
        if(active != 0){
          this.$router.push({name:"elections",params:{id:id,des:des,title:title,status:status}});
        }else{
          this.$toast.open({
            message: 'این قسمت فعال نیست و امکان ورود ندارد.',
            type: 'error'
          });
        }

      }else{

        this.$toast.open({
          message: 'شما نیاز به ورود به برنامه دارید',
          type: 'error'
        });

        this.$toast.open({
          message: 'به صفحه ورود و ثبت نام منتقل میشوید',
          type: 'error'
        });

        setTimeout(()=>{
          this.$router.push('/login');
        },2000);

      }
    }
  },
};
</script>

<style lang="scss" scoped>
.voting-module {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/img/bg/talent_back.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0px;
  direction: rtl;
  .title-box{

    h4{
      text-align: center;
    }
    .talent-des{
      text-align: center;
    }
  }
  .order-vote{
    .plusicon svg{
      background: #e91e63;
      border-radius: 50%;
      color: #ffff;
    }
  }
  .voting-lists{
    padding: 15px;
    .vote-item{
      background: #ffffff;
      padding: 14px;
      border: 1px solid #bdbdbd;
      border-radius: 15px;
      .title-box{
        text-align: center;
      }
     .vote-image-background{
         img{
            width:100%;
         }
     }
      .disActiveVote img{
        -webkit-filter: grayscale(100%) brightness(120%) opacity(0.7); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%) brightness(120%) opacity(0.7);
      }
    }
  }

  .voting-plus-icon{
    background: #e91e63;
    border-radius: 50%;
    color: #ffff;
    display: flex;
    justify-content: center;
    width: 60px;
    height: 60px;
    align-items: center;
    margin-top: 0;
    margin-bottom: 0;
    position: fixed;
    bottom: 10px;
    right: 13px;
    z-index: 999;
    .plusicon{
      display: flex;
      justify-content: center;
      align-content: center;
      svg{
        transform: scale(3);
      }
    }
  }
}
</style>
